import { Button, Input, Space, Table, Tag } from "antd";
import { EditOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadAllStaff } from "../../redux/rtk/features/user/userSlice";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import ViewBtn from "../Buttons/ViewBtn";
import BtnViewSvg from "../UI/Button/btnViewSvg";

function GetAllMeetings({ data = [], onEdit, onRefresh }) {
	const dispatch = useDispatch();
	const [columnsToShow, setColumnsToShow] = useState([]);
	const [searchEmployee, setSearchEmployee] = useState("");
	const [searchManager, setSearchManager] = useState("");
	const staffList = useSelector((state) => state.users?.list || []);

	useEffect(() => {
		dispatch(loadAllStaff({ status: true }));
	}, [dispatch]);

	const mapEmployeeName = (employeeId) => {
		const employee = staffList.find((e) => e.id === employeeId);
		if (employee) {
			return (
				employee.EmployeeName ||
				`${employee.firstName || ""} ${employee.lastName || ""}`.trim() ||
				employee.UserName
			);
		}
		return employeeId;
	};

	const columns = [
		{
			id: 1,
			title: "S.No",
			dataIndex: "serial",
			key: "serial",
		},
		{
			title: "Manager",
			dataIndex: "managerName",
			key: "managerName",
		},
		{
			title: "Employee",
			dataIndex: "employeeName",
			key: "employeeName",
		},
		{
			title: "Meeting Date",
			dataIndex: "meetingDate",
			key: "meetingDate",
			render: (date) => (date ? dayjs(date).format("DD-MM-YYYY") : "-"),
		},
		{
			title: "Meeting Time",
			dataIndex: "meetingTime",
			key: "meetingTime",
			render: (time) => time || "-",
		},
		{
			title: "Location",
			dataIndex: "location",
			key: "location",
		},
		{
			title: "Agenda",
			dataIndex: "agenda",
			key: "agenda",
			render: (agenda) =>
				agenda
					? agenda.substring(0, 30) + (agenda.length > 30 ? "..." : "")
					: "-",
		},
		{
			title: "Status",
			dataIndex: "status",
			key: "status",
			render: (status) => {
				if (status === "Completed") {
					return <Tag color="green">Completed</Tag>;
				} else if (status === "Cancelled") {
					return <Tag color="red">Cancelled</Tag>;
				} else if (status === "Postponed") {
					return <Tag color="orange">Postponed</Tag>;
				} else {
					return <Tag color="blue">Scheduled</Tag>;
				}
			},
		},
		{
			title: "Actions",
			key: "action",
			render: (_, record) => {
				const id = record.id;
				return (
					<Space>
						<ViewBtn
							path={`/admin/meeting/${id}`}
							text="View"
							icon={<BtnViewSvg />}
						/>
						<Button
							type="link"
							icon={<EditOutlined />}
							onClick={() => onEdit && onEdit(record)}
						/>
					</Space>
				);
			},
		},
	];

	useEffect(() => {
		setColumnsToShow(columns);
	}, []);

	const columnsToShowHandler = (val) => {
		setColumnsToShow(val);
	};

	const addKeys = (arr) =>
		(Array.isArray(arr) ? arr : []).map((i, index) => ({
			...i,
			key: i.id || index,
			serial: index + 1,
			managerName: i.managerName || mapEmployeeName(i.managerId),
			employeeName: i.employeeName || mapEmployeeName(i.employeeId),
		}));

	const filteredData = addKeys(data).filter((item) => {
		const employeeName = (item.employeeName || "").toLowerCase();
		const managerName = (item.managerName || "").toLowerCase();
		const matchesEmployee = employeeName.includes(searchEmployee.toLowerCase());
		const matchesManager = managerName.includes(searchManager.toLowerCase());
		return matchesEmployee && matchesManager;
	});

	return (
		<div className="meeting-table-container">
			<div className="text-center my-2 flex justify-between items-center">
				<h5 className="text-color-2 text-xl mb-2">Meetings List</h5>
				{data && data.length > 0 && (
					<div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
						<ColVisibilityDropdown
							options={columns}
							columns={columns}
							columnsToShowHandler={columnsToShowHandler}
						/>
						<Input
							placeholder="Search by Employee"
							value={searchEmployee}
							onChange={(e) => setSearchEmployee(e.target.value)}
							style={{ width: 200 }}
						/>
						<Input
							placeholder="Search by Manager"
							value={searchManager}
							onChange={(e) => setSearchManager(e.target.value)}
							style={{ width: 200 }}
						/>
					</div>
				)}
			</div>

			<Table
				scroll={{ x: true }}
				loading={false}
				columns={columnsToShow}
				dataSource={filteredData}
				pagination={{
					pageSize: 10,
					showSizeChanger: true,
					showTotal: (total, range) =>
						`${range[0]}-${range[1]} of ${total} items`,
					pageSizeOptions: ["10", "20", "50", "100"],
				}}
			/>
		</div>
	);
}

export default GetAllMeetings;

